import React from 'react';
import './SudokuResult.css';

const SudokuResult = ({ isCorrect, onPlayAgain, onBackToMenu }) => {
  return (
    <div className="sudoku-result-overlay">
      <div className={`sudoku-result-content ${isCorrect ? 'correct' : 'incorrect'}`}>
        <div className="result-header">
          {isCorrect ? (
            <>
              <h2 className="result-title correct">おめでとうございます！</h2>
              <div className="result-emoji">🎉</div>
            </>
          ) : (
            <>
              <h2 className="result-title incorrect">残念...</h2>
              <div className="result-emoji">😢</div>
            </>
          )}
        </div>
        
        <div className="result-message">
          {isCorrect ? (
            <p>数独を正しく解くことができました！</p>
          ) : (
            <p>入力した数字に間違いがあります。<br />もう一度挑戦してみましょう！</p>
          )}
        </div>
        
        <div className="result-buttons">
          <button className="play-again-button" onClick={onPlayAgain}>
            もう一度遊ぶ
          </button>
          <button className="back-to-menu-button" onClick={onBackToMenu}>
            メニューに戻る
          </button>
        </div>
      </div>
    </div>
  );
};

export default SudokuResult;